import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Campaign } from '~/api/models/campaign';
import CampaignStatusLabel from '../CampaignStatusLabel';
import { useCampaign } from '../../hooks/useCampaign';

export const getTimeSinceUpdate = (lastChange) => {
    if (!lastChange) {
        return <FormattedMessage id='intl-msg:unknown'/>;
    }
    const updatedDate = new Date(lastChange);
    const now = new Date();
    const diffTime = Math.abs(now.getTime() - updatedDate.getTime());

    const minutes = Math.floor(diffTime / (1000 * 60));
    const hours = Math.floor(diffTime / (1000 * 60 * 60));
    const days = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (days > 0) {
        return <FormattedMessage id='intl-msg:campaign:lastChange:daysAgo' values={{ days }}/>;
    }
    if (hours > 0) {
        return <FormattedMessage id='intl-msg:campaign:lastChange:hoursAgo' values={{ hours }}/>;
    }
    return <FormattedMessage id='intl-msg:campaign:lastChange:minutesAgo' values={{ minutes }}/>;
};

interface CampaignHeaderProps {
    campaign: Campaign;
}

const CampaignHeader: React.FC<CampaignHeaderProps> = ({ campaign: initialCampaign }) => {
    const [progressPercentage, setProgressPercentage] = useState<number>(30);
    const { campaign: currentCampaign } = useCampaign(initialCampaign);





    return (
        <div className=''>
            <div className='display-flex gap-10 width-100pct align-items-center margin-bottom-10 margin-top-20'>
                <h2 className={'margin-0'}> {currentCampaign?.name} </h2>
                <CampaignStatusLabel status={currentCampaign?.status} />
            </div>
            <div className={'margin-bottom-10 '}>
                {currentCampaign?.currentStage ?
                    <span className={'title  text-decoration-underline'}>
                    <FormattedMessage id='intl-msg:campaign:currentStage'
                                      values={{ stage: currentCampaign.stages?.find(s => s.id === currentCampaign.currentStage)?.stageOrder || currentCampaign.currentStage }}/> </span> :
                    <FormattedMessage id="intl-msg:campaign:notStarted" />
                } | <FormattedMessage
                id='intl-msg:campaign:lastChange'/> {getTimeSinceUpdate(currentCampaign?.updatedDate)}
            </div>
            <div className={'display-flex flex-row align-items-baseline width-100pct gap-10'}>
                <div className='margin-left-5 text-size-14'>
                    {`${currentCampaign?.progress}%`}
                </div>
                <div className="progress margin-bottom-20 width-100pct" style={{border: '1px solid #ccc'}}>
                    <div className="progress-bar progress-bar-info" style={{width: `${currentCampaign?.progress}%`}}>
                    </div>
                </div>
                <div className='margin-left-5 text-size-14'>
                    {currentCampaign?.updatedVehicles || 0}/{currentCampaign?.totalVehicles || 0}
                </div>
            </div>

        </div>
    );
};

export default CampaignHeader;
